import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function editMilestone(
  milestone: Identifiable<Milestone>,
  nextMilestone: Milestone,
): Identifiable<Milestone> {
  return {
    ...milestone,
    ...nextMilestone,
  };
}

function handleConstrainElements(
  milestone: Identifiable<Milestone>,
  { impactedElements }: Boundaries["constrainElements"]["success"],
): Identifiable<Milestone> {
  const impactedMilestone = impactedElements.find(
    ({ uuid }) => uuid === milestone.uuid,
  );

  return !!impactedMilestone
    ? editMilestone(milestone, { ...milestone, ...impactedMilestone })
    : milestone;
}

export { handleConstrainElements };
